import http from "@/http";
// 注册
export const registered = data => {
  return http({
    url: "/user/registered",
    method: "post",
    data
  });
};

// 登陆
// http://base.leubao.com/login
export const login = data => {
  return http({
    url: "/login",
    method: "post",
    data
  });
};

// 注销登录
export const loginOut = params => {
  return http({
    url: "/api/self/logout",
    method: "post",
    params
  });
};
//用户信息
export const getUserInfo = params => {
  return http({
    url: "/v1/self",
    method: "get",
    params
  });
};
// 修改密码
export const upDataPassword = {
  p: "/update_password",
  r: data => {
    return http({
      url: "/api/self/update_password",
      method: "post",
      data
    });
  }
};
//权限菜单
export const getPermission = params => {
  return http({
    url: "/v1/menu",
    method: "get",
    params
  });
};

// 刷新token
export const tokenRefresh = params => {
  return http({
    url: "/v1/token",
    method: "get",
    params
  });
};

// 获取用户权限菜单
export const getUserMenu = params => {
  return http({
    url: "/v1/user_menu",
    method: "get",
    params
  });
};
// 微信授权二维码
// https://api.msg.alizhiyou.cn/v1/wechat
export const getWechatRcode = {
  p: "/v1/wechat",
  r: data => {
    return http({
      url: "/v1/wechat",
      method: "get",
      data
    });
  }
};
